import { render } from "./DateOfBirth.vue?vue&type=template&id=c13dc88c"
import script from "./DateOfBirth.vue?vue&type=script&lang=js"
export * from "./DateOfBirth.vue?vue&type=script&lang=js"

import "./DateOfBirth.vue?vue&type=style&index=0&id=c13dc88c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__